import { useAccount } from 'wagmi';

import { Loader } from '@/components/Loader';
import { GridStatsCardsSection } from '@/components/shared/GridStatsCard';

import { ConnectWallet } from './ConnectWallet';
import LandingDataStats from './LandingDataStats';
import LoanStats from './LoanStats';
import PortfolioStats from './PortfolioStats';
import WalletButtons from './WalletButtons';
import MyLoansTable from '../borrow-land/MyLoansTable';

export interface IConnectionProviderProps {
  connectWalletText?: string;
}

const ConnectionProvider: React.FC<IConnectionProviderProps> = ({ connectWalletText }) => {
  const { isConnected, isConnecting } = useAccount();

  return (
    <>
      {isConnecting ? (
        <Loader />
      ) : isConnected ? (
        <div className='flex flex-col h-full'>
          <GridStatsCardsSection title='Portfolio'>
            <PortfolioStats />
          </GridStatsCardsSection>
          <GridStatsCardsSection title='Borrowing Data'>
            <LoanStats />
          </GridStatsCardsSection>
          <GridStatsCardsSection title='Lending Data'>
            <LandingDataStats />
          </GridStatsCardsSection>

          <MyLoansTable />

          {/* <div className='flex-1 h-full'>
            <div className='bg-light-blue-grey dark:bg-jet-black lg:bg-transparent pt-6 border-t-0 lg:pt-0'>
              <NFTCollection />
            </div>
          </div> */}
        </div>
      ) : (
        <div className='h-full flex items-center justify-center my-auto'>
          <ConnectWallet text={connectWalletText}>
            <WalletButtons />
          </ConnectWallet>
        </div>
      )}
    </>
  );
};

export default ConnectionProvider;
